<div class="claro-pageloader" [ngClass]="{ 'is-active' : $bIsLoaderActive | async}">
  <img [src]="logoUrl" alt="Loading...">
</div>
